<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2>Role Administration</h2>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <card>
          <div slot="header"><h4 class="card-title">Roles</h4></div>
          <div class="row">
            <div class="col-sm-12">
              <el-table :data="roles">
                <el-table-column min-width="200" prop="name" label="Name"></el-table-column>
                <el-table-column mind-width="200" align="right" label="Actions">
                  <template scope="scope">
                    <base-button v-if="scope.row.userRoles.length === 0" class="btn-link" type="secondary" size="sm" icon>
                      <span class="sr-only">Edit Role</span>
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                    <base-button v-if="scope.row.userRoles.length === 0" @click="onDelete(scope.row.name)" class="btn-link" type="danger" size="sm" icon>
                      <span class="sr-only">Delete Role</span>
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from 'element-ui';
import { getRoles, deleteRole } from 'src/modules/adminActions';
import BaseButton from 'src/components/BaseButton.vue';
import swal from 'sweetalert2';

export default {
  components: {
    BaseButton,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      roles: []
    }
  },
  methods: {
    sortRoles() {
      this.roles.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    },
    onDelete(name) {
      swal.fire({
        title: 'Delete Role',
        text: 'Are you sure you want to delete the Role "' + name + '"?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          let payload = {
            RoleName: name,
          };

          deleteRole(payload)
          .then(response => {
            let identityResult = response.data.result;
            let errorMessage = '';

            if(identityResult.errors && identityResult.errors.length) {
              identityResult.errors.forEach(error => {
                errorMessage += `${error.description}<br>`
              });
              swal('Role Delete Error', errorMessage, 'error');
            }
            else {
              this.roles = response.data.roles;
              this.sortRoles();
              swal('Role "' + name + '" deleted', '', 'success');
            }
          });
        }
      })
    },
  },
  created() {
    getRoles()
      .then((response) => {
        this.roles = response.data;
        this.sortRoles();
      });
  }
};
</script>
